/* eslint-disable */
var $ = window.jQuery = require('jquery');

import { VueEditor } from "vue2-editor";
import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
import toast from '../../services/toast';

export default {
  name: 'tabDetailsCreate',
  components: {
    draggable,
    VueEditor
  },
  data() {
    return {
      submitted: false,
      tabData: {
        category: '',
        courseId: '',
        tabId: '',
        name: 'Other',
        description: '',
        isActive: false,
        tabBulletPoint: '',
        columnIndex: 0
      },
      tab_name: '',
      editBulletPoint: '',
      selectedBulletID: '',
      BulletsListEnabled: false,
      updateBulletsData: false,
      bulletsPointListFirst: [],
      bulletsPointListSecond: [],
      bulletsPointListThird: [],
      coursesection:null,
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
  },
  mounted() {
    this.tabData.courseId = this.$route.params.courseId;
  },
  beforeMount() {},
  watch: {},
  methods: {
    getCourseTabDetailsAgain() {
      this.$store.dispatch('getCourseTabDetailsByID', {
        id: this.tabData.tabId
      }).then((res) => {
        this.tabDetails = this.$store.getters.getcourseDetailstabByIDState.data;
        this.tabData.name = this.tabDetails.data.name
        this.tabData.description = this.tabDetails.data.content;
        this.tabData.courseId = this.tabDetails.data.course;
        this.tabData.isActive = this.tabDetails.data.is_active;
        if (this.tabDetails.data.lists) {
          this.bulletsPointListFirst = this.tabDetails.data.lists.filter(item => item.column_index == 0);
          this.bulletsPointListSecond = this.tabDetails.data.lists.filter(item => item.column_index == 1);
          this.bulletsPointListThird = this.tabDetails.data.lists.filter(item => item.column_index == 2);
        }
      }).catch((err) => {})
    },

    validateCourseTabSubmit(e) {
      this.BulletsListEnabled = false;
      this.tabData.tabId = '';
      this.bulletsPointListFirst = [];
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.tabData.name,
            content: this.tabData.description,
            course: this.tabData.courseId,
            is_active: this.tabData.isActive
          }
          this.$store.dispatch('course_details_tab', data).then((res) => {
              if (res.status == '201') {
                this.tabData.tabId = res.data.data.id;
                this.tab_name = res.data.data.name;
                this.BulletsListEnabled = true;
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {})
          return
        }
      });
    },

    onChange(event) {
      this.tabData.name = event.target.value
      if (this.tabData.name == this.tabData.name && this.tabData.name !== 'Other') {
        $('#tabName').attr("disabled", true);
      } else if (this.tabData.name == 'Other') {
        // debugger
        $('#tabName').attr("disabled", false);
        $('#tabName').focus(function() {
          // debugger
          if ($(this).val() == 'Other') $(this).val("");
          console.log($(this).val())
        })
      } else {
        $('#tabName').attr("disabled", false);
      }
    },

    valueBlank() {
      if (this.tabData.name == 'Other') {
        this.tabData.name = '';

      }
    },

    validateCreateBulletBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            content: this.tabData.tabBulletPoint,
            course_detail_tab: this.tabData.tabId,
            column_index: this.tabData.columnIndex
          }
          this.$store.dispatch('create_bullets_list', data).then((res) => {
              if (res.status == '201') {
                this.tabData.tabBulletPoint = '';
                this.getCourseTabDetailsAgain();
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {
              toast.error("Please Create Tab First");
            })
          return
        }
      });
    },

    PopupClose() {
      this.updateBulletsData = false
    },

    updateBullet(bulletPointId) {
      this.updateBulletsData = true;
      this.selectedBulletID = bulletPointId;
      let data = {
        id: bulletPointId
      }
      this.$store.dispatch('GetBulletdataByID', data)
        .then((res) => {
          this.editBulletPoint = this.$store.getters.getBulletDataByIDState.data.content
        })
        .catch((err) => {})
    },
    updateBulletConfirmation() {
      let data = {
        content: this.editBulletPoint
      }
      this.$store.dispatch('UpdateBulletPointById', {
          data: {
            data: data,
            id: this.selectedBulletID
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseTabDetailsAgain();
          this.updateBulletsData = false
        })
        .catch((err) => {})
    },
    removeBUlletagain(id) {
      $('#removeBulletModalAgain').modal();
      $('body').addClass('removeOverlay');
      this.selectedBulletID = id
    },
    removeBUlletClose() {
      $('body').removeClass('removeOverlay');
    },
    removeBulletConfirmationagain() {
      let data = {
        id: this.selectedBulletID
      }
      this.$store.dispatch('remove_bullets_list', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg);
            this.getCourseTabDetailsAgain();
            $('body').removeClass('removeOverlay');
          }
        })
        .catch((err) => {})
    },
    bulletSort: function(event) {
      if (event.moved && event.moved != undefined) {
        const newColumnIndex = this.getBulletPointIndex(event.moved.element.id);
        this.updateBulletPointIndex(event.moved.element.id, newColumnIndex, Number(event.moved.newIndex) + 1);
      }
      if (event.added && event.added != undefined) {
        const newColumnIndex = this.getBulletPointIndex(event.added.element.id);
        this.updateBulletPointIndex(event.added.element.id, newColumnIndex, Number(event.added.newIndex) + 1);
      }
    },
    getBulletPointIndex(bulletPointId) {
      let columnIndex = 0;
      let listResult1 = this.bulletsPointListFirst.filter(item => item.id == bulletPointId);
      let listResult2 = this.bulletsPointListSecond.filter(item => item.id == bulletPointId);
      let listResult3 = this.bulletsPointListThird.filter(item => item.id == bulletPointId);
      if (listResult1 && listResult1.length > 0) {
        columnIndex = 0;
      }
      if (listResult2 && listResult2.length > 0) {
        columnIndex = 1;
      }
      if (listResult3 && listResult3.length > 0) {
        columnIndex = 2;
      }
      return columnIndex;
    },
    updateBulletPointIndex(bulletPointId, columnIndex, rowIndex) {
      let data = {
        index: rowIndex,
        column_index: columnIndex
      }
      this.$store.dispatch('UpdateBulletPointIndex', {
          data: {
            data: data,
            id: bulletPointId
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseTabDetailsAgain();
          this.updateBulletsData = false
        })
        .catch((err) => {})
    }
  },
  beforeCreate: function() {
    $('body').addClass('tab_details')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('tab_details')
    next();
  }
}